'use client';

import * as React from 'react';

import { cn } from '../../lib/utils';

export type LabelProps = React.LabelHTMLAttributes<HTMLLabelElement>;

/**
 * Label component for Input
 *
 * * `margin botton` of fixed 10px.
 */

const Label = React.forwardRef<HTMLLabelElement, LabelProps>(
  ({ className, ...props }, ref) => (
    <label
      ref={ref}
      className={cn('mb-[10px] text-h8 font-bold', className)}
      {...props}
    />
  )
);
Label.displayName = 'Label';

export default Label;
